<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form-model :model="model" :rules="validatorRules" ref="form" slot="detail">
        <a-row>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="APPID" prop="appId">
              <a-input placeholder="请输入APPID" v-model="model.appId"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="客户端" prop="appClient">
              <j-dict-select-tag
                dictCode="app_client"
                placeholder="请选择客户端"
                type="radioButton"
                v-model="model.appClient"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="内部版本号" prop="version">
              <a-input-number placeholder="请输入内部版本号" style="width: 100%" v-model="model.version" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="外部版本号" prop="versionCode">
              <a-input placeholder="请输入外部版本号" v-model="model.versionCode"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="更新方式" prop="upgradeType">
              <j-dict-select-tag
                dictCode="app_upgrade_type"
                placeholder="请选择更新方式"
                type="radioButton"
                v-model="model.upgradeType"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="安装包" prop="upgradeUrl">
              <j-upload v-model="model.upgradeUrl"></j-upload>
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="强制更新" prop="isForce">
              <j-dict-select-tag dictCode="yn" type="radioButton" v-model="model.isForce" />
            </a-form-model-item>
          </a-col>
          <a-col :span="12">
            <a-form-model-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发布模式" prop="releaseMode">
              <j-dict-select-tag dictCode="app_release_mode" type="radioButton" v-model="model.releaseMode" />
            </a-form-model-item>
          </a-col>

          <a-col :span="24" v-show="model.releaseMode === 'gray'">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="灰度百分比" prop="grayPercentage">
              <a-input-number :max="100" :min="1" @change="grayPercentageChange" v-model="model.grayPercentage" />
            </a-form-model-item>
          </a-col>

          <a-col :span="24" v-show="model.releaseMode === 'specific'">
            <a-form-model-item :labelCol="labelCol2" :wrapperCol="wrapperCol2" label="升级用户" prop="specificUsers">
              <j-multi-select-tag
                dictCode="`iwt-wf`.wf_consumer_user,nickname,id"
                placeholder="请选择需要升级的用户"
                type="list_multi"
                v-model="specificUsers"
              />
            </a-form-model-item>
          </a-col>

          <a-col :span="24">
            <a-form-model-item
              :labelCol="{xs: { span: 24 },sm: { span: 3 }}"
              :wrapperCol="{xs: { span: 24 },sm: { span: 20 }}"
              label="升级说明"
              prop="upgradePoint"
            >
              <j-editor v-model="model.upgradePoint" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>
    </j-form-container>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import { validateDuplicateValue } from '@/utils/util'

  export default {
    name: 'AppVersionUpgradeLogForm',
    components: {
    },
    props: {
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        model: {
          isForce: 1,
          releaseMode: 'full',
          grayPercentage: 10,
        },
        specificUsers: "",
        labelCol: {
          xs: { span: 24 },
          sm: { span: 6 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        labelCol2: {
          xs: { span: 24 },
          sm: { span: 3 },
        },
        wrapperCol2: {
          xs: { span: 24 },
          sm: { span: 20 },
        },
        confirmLoading: false,
        validatorRules: {
          appId: [
            { required: true, message: '请输入APPID!' },
          ],
          appClient: [
            { required: true, message: '请输入客户端!' },
          ],
          versionCode: [
            { required: true, message: '请输入外部版本号!' },
          ],
          upgradeType: [
            { required: true, message: '请输入更新方式!' },
          ],
          upgradeUrl: [
            { required: true, message: '请输入安装包!' },
          ],
        },
        url: {
          add: "/custom/appVersion/add",
          edit: "/custom/appVersion/edit",
          queryById: "/custom/appVersion/queryById",
          querySpecificUsersList: "/custom/appVersion/queryByAppId",
        }
      }
    },
    computed: {
      formDisabled () {
        return this.disabled
      },
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add () {
        this.edit(this.modelDefault);
      },
      edit (record) {
        this.model = Object.assign({}, record);
        if(record.id && record.releaseMode === 'specific'){
            this.querySpecificUsersList();
        }
        this.visible = true;
      },
      querySpecificUsersList () {
        getAction(this.url.querySpecificUsersList, {
          id: this.model.id,
        }).then(res => {
          if (res.success) {
            this.specificUsers = res.result.map(item => item.userId).join(',');
          }
        })
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {

            if (this.model.releaseMode === 'specific') {
              const specificUsersArr = this.specificUsers.split(',').filter(Boolean);
              if (specificUsersArr.length === 0) {
                this.$message.warning('请选择升级用户');
                return;
              }
              this.model.grayPercentage = 0;

              const subTablesData = specificUsersArr.map(item => {
                return {
                  userId: item
                }
              });
              this.model.appVersionUpgradeSpecificUsersList = subTablesData;
            } else if (this.model.releaseMode === 'full') {
              this.model.grayPercentage = 0;
            }

            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if (!this.model.id) {
              httpurl += this.url.add;
              method = 'post';
            } else {
              httpurl += this.url.edit;
              method = 'put';
            }
            httpAction(httpurl, this.model, method).then((res) => {
              if (res.success) {
                that.$message.success(res.message);
                that.$emit('ok');
              } else {
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }

        })
      },
      grayPercentageChange (value) {
        if (value >= 100) {
          this.model.releaseMode = 'full';
          this.model.grayPercentage = 10;
        }
      }
    }
  }
</script>